import { FC, ReactNode, useContext } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { TreeItem } from '@mui/x-tree-view';
import { StorageContext } from '~/hooks';
import { InfoIcon } from '~/icons';
import { FolderTreeItemActions } from '..';
import { folderNameTypographyStyles, folderTreeItemStyles } from './styles';

interface RootFolderTreeItemProps {
  children: ReactNode;
}

const RootFolderTreeItem: FC<RootFolderTreeItemProps> = ({ children }) => {
  const storageContext = useContext(StorageContext);

  return (
    <>
      <TreeItem
        itemId=""
        label={
          <Box sx={folderTreeItemStyles}>
            <Box display="flex" alignItems="center" gap="1rem">
              <Typography sx={folderNameTypographyStyles(!storageContext?.lastClickedItem)}>Root folder</Typography>
              <Tooltip placement="bottom" title="This folder is the root  in the structure and it can’t be deleted.">
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <InfoIcon />
                </Box>
              </Tooltip>
            </Box>
            {!storageContext?.lastClickedItem && <FolderTreeItemActions isRootFolder path="" />}
          </Box>
        }
        key=""
      >
        {children}
      </TreeItem>
    </>
  );
};

export default RootFolderTreeItem;
